import { useEffect } from 'react'
import { useAppDispatch, useAppSelector } from '../../../hooks/redux'
import { setResponseSuccessShow } from '../../../store/reducers/app/ResponseInfoSlices'
import ResponseSuccess from './ResponseSuccess'

let ResponseSuccessContainer = () => {

    const dispatch = useAppDispatch()

    const success = useAppSelector<number | null>(state => state.responseInfo.success)
    const successShow = useAppSelector<boolean>(state => state.responseInfo.successShow)

    useEffect(
        () => {
            if(successShow){
                setTimeout(() => {
                    dispatch(setResponseSuccessShow(false))
                }, 1000)
            }
        }, [dispatch, successShow]
    )

    return (
        <>
            {successShow
                ?
                    <ResponseSuccess
                        success={success}
                    />
                : null
            }
        </>
    )
}

export default ResponseSuccessContainer